// Super Admin grants access to every organization's data, so it is restricted to Zapit's own
// email domain and to sessions established via SSO. Mirrors the same checks enforced server-side
// in zapit-api (super-admin.util.ts and jwt.strategy.ts) - this frontend copy only drives UI
// gating (menus, the AdminUserDetail switch); the API is the source of truth.
export const SUPER_ADMIN_EMAIL_DOMAIN = "enzeehealth.com";

/**
 * Whether the given email address is eligible to hold Super Admin.
 */
export function isSuperAdminEligibleEmail(email: string | null | undefined): boolean {
  return (email || "").trim().toLowerCase().endsWith(`@${SUPER_ADMIN_EMAIL_DOMAIN}`);
}

/**
 * Whether an AuthSession's clientType represents an SSO sign-in (any OrgSsoConfig-registered
 * provider) rather than a Cognito username/password sign-in ("app").
 */
export function isSsoClientType(clientType: string | null | undefined): boolean {
  return clientType === "sso" || clientType === "microsoftIdp";
}
